import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/Layout/DashboardLayout";
import { LayoutDashboard, Menu as MenuIcon, ShoppingBag, CreditCard } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { useCurrency } from "@/contexts/CurrencyContext";

const items = (t) => [
  { to: "/restaurant", icon: LayoutDashboard, label: t("dashboard"), end: true, tid: "rest-nav-dashboard" },
  { to: "/restaurant/menu", icon: MenuIcon, label: t("menu"), tid: "rest-nav-menu" },
  { to: "/restaurant/orders", icon: ShoppingBag, label: t("orders"), tid: "rest-nav-orders" },
  { to: "/restaurant/subscription", icon: CreditCard, label: t("subscription"), tid: "rest-nav-subscription" },
];

const STATUS_TINT = {
  pending: "bg-amber-500/10 text-amber-700",
  confirmed: "bg-blue-500/10 text-blue-700",
  preparing: "bg-indigo-500/10 text-indigo-700",
  ready: "bg-purple-500/10 text-purple-700",
  picked_up: "bg-orange-500/10 text-orange-700",
  out_for_delivery: "bg-orange-500/10 text-orange-700",
  delivered: "bg-emerald-500/10 text-emerald-700",
};

export default function RestaurantOrders() {
  const { t } = useLang();
  const { formatPrice } = useCurrency();
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/orders/mine").then(r => setOrders(r.data));
  useEffect(() => { load(); const i = setInterval(load, 5000); return () => clearInterval(i); }, []);

  const advance = async (id) => { await api.post(`/orders/${id}/advance`); load(); };

  return (
    <DashboardLayout items={items(t)} title={t("orders")}>
      <div className="space-y-2">
        {orders.length === 0 && <div className="text-[var(--so-text-soft)] text-sm py-8 text-center">No orders yet.</div>}
        {orders.map((o) => (
          <div key={o.id} className="so-card p-4 flex items-center gap-3" data-testid={`r-order-${o.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-bold">{o.customer_name} · #{o.id.slice(0, 6)}</div>
              <div className="text-xs text-[var(--so-text-soft)]">{o.items.length} items · {formatPrice(o.total)} · {new Date(o.created_at).toLocaleString()}</div>
              <div className="text-xs mt-1">{o.items.map(i => `${i.quantity}× ${i.name}`).join(", ")}</div>
            </div>
            <span className={`text-[10px] font-bold uppercase px-2 py-1 rounded-full ${STATUS_TINT[o.status]}`}>{t(o.status)}</span>
            {["pending", "confirmed", "preparing"].includes(o.status) && (
              <button onClick={() => advance(o.id)} className="so-btn-primary text-xs py-1.5 px-3" data-testid={`r-advance-${o.id}`}>
                {o.status === "pending" ? "Confirm" : o.status === "confirmed" ? "Start" : "Ready"}
              </button>
            )}
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
